<template>
	<div class="modal fade" :id="line" tabindex="-1" role="dialog">
	  <div class="modal-dialog" role="document">
	    <div class="modal-content">
	      <!--<div class="modal-header">
	        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
	        <h4 class="modal-title">Comprovante de cancelamento</h4>
	      </div> -->
	      <div class="modal-body">
	        <header class="site-header-3 site-header" style="border-top: 5px solid #29b6f6;">
	            <!-- Main bar start -->
	            <div id="sticked-menu" class="main-bar">
	                <div class="">                
	                    <div class="row">                    
	                        <div class="col-md-12">
	                        <!-- logo begin -->
	                            <div id="logo" class="site-logo">                            
                                    <a :href="dadosmodal.linklogo">
                                        <img :src="dadosmodal.imglogo" alt="" class="logo logo-principal">
                                        <div class="nomes-logo">
                                            <span>{{dadosmodal.tipoentidade}}</span>
                                            <h1>{{dadosmodal.nomeentidade}}</h1>
                                        </div>
                                    </a>
                                </div>
	                             <!-- logo close -->
	                            <div class="title-system pull-right" style="">
	                                <p class="title-ouvi">{{dadosmodal.nomesistema}}</p>
	                                <p class="sub-title-ouvi">{{dadosmodal.publicacao}}</p>
	                            </div>
	                        </div>
	                    </div>
	                </div>
	            </div>
	        </header>
	        <div>
	        	<h4>Assinatura de {{certificado.titular}}</h4>
	        </div>

	        <br>
	        <div class="row">
	            <div class="col-md-12">
	            	<div class="portlet-body">
			            <div class="table-scrollable" style="height: 383px; overflow-y: auto;">
		                	<table class="table">
		                    <tbody>
		                        <tr>
		                            <td class="titulotable" width="19%" align="right" style="background-color: #eee;"> Data/hora </td>
		                            <td class="conteudotable">
		                                {{dadosmodal.datahora}}
		                            </td>
		                        </tr>
		                        <tr>
		                            <td class="titulotable" align="right" style="background-color: #eee;"> Política de assinatura </td>
		                            <td class="conteudotable"> {{dadosmodal.politicaassinatura}} </td>
		                        </tr>
		                        <tr>
		                        	<td class="titulotable" style="background-color: #eee;" colspan="2"><i class="fa fa-circle-o" style="font-size: 14px;"></i> Certificado</td>
		                        </tr>
		                        <tr>
			                        <td class="titulotable" width="19%" align="right" style="background-color: #eee;"> Titular </td>
			                        <td class="conteudotable">
			                              {{certificado.titular}}
			                        </td>
		                        </tr>
		                        <tr>
		                            <td class="titulotable" align="right" style="background-color: #eee;"> CPF
		                            <td class="conteudotable">
		                               {{certificado.cpf}}
		                            </td>
		                        </tr>
		                        <tr>
		                           <td class="titulotable" width="19%" align="right" style="vertical-align: top !important; background-color: #eee;"> Validade </td>
		                            <td class="conteudotable">
		                               {{certificado.validade}}
		                            </td> 
		                        </tr>
		                        <tr>
		                           <td class="titulotable" width="19%" align="right" style="vertical-align: top !important; background-color: #eee;"> Email </td>
		                            <td class="conteudotable" style="text-transform: none">
		                               {{certificado.email}}
		                            </td> 
		                        </tr>
		                        <tr>
		                        	<td class="titulotable" style="background-color: #eee; " colspan="2"><i class="fa fa-circle-o" style="font-size: 14px;"></i> Emissor </td>
		                        </tr>
		                        <tr>
		                           <td class="titulotable" width="19%" align="right" style="vertical-align: top !important; background-color: #eee;"> Titular </td>
		                            <td class="conteudotable">{{emissorum.titular}}</td> 
		                        </tr>
		                        <tr>
		                           <td class="titulotable" width="19%" align="right" style="vertical-align: top !important; background-color: #eee;"> Validade </td>
		                            <td class="conteudotable">{{emissorum.validade}}</td> 
		                        </tr>
		                        <tr>
		                        	<td class="titulotable" style="background-color: #eee;" colspan="2"><i class="fa fa-circle-o" style="font-size: 14px;"></i> Emissor </td>
		                        </tr>
		                        <tr>
		                           <td class="titulotable" width="19%" align="right" style="vertical-align: top !important; background-color: #eee;"> Titular </td>
		                            <td class="conteudotable">{{emissordois.titular}}</td> 
		                        </tr>
		                        <tr>
		                           <td class="titulotable" width="19%" align="right" style="vertical-align: top !important; background-color: #eee;"> Validade </td>
		                            <td class="conteudotable">{{emissordois.validade}}</td> 
		                        </tr>
		                        <tr>
		                        	<td class="titulotable" style="background-color: #eee;" colspan="2"><i class="fa fa-circle-o" style="font-size: 14px;"></i> Emissor </td>
		                        </tr>
		                        <tr>
		                           <td class="titulotable" width="19%" align="right" style="vertical-align: top !important; background-color: #eee;"> Titular </td>
		                            <td class="conteudotable">{{emissortreis.titular}}</td> 
		                        </tr>
		                        <tr>
		                           <td class="titulotable" width="19%" align="right" style="vertical-align: top !important; background-color: #eee;"> Validade </td>
		                            <td class="conteudotable">{{emissortreis.validade}}</td> 
		                        </tr>
		                        <tr>
		                        	<td class="titulotable" style="background-color: #eee;" colspan="2"><i class="fa fa-circle-o" style="font-size: 14px;"></i> Atributos assinados </td>
		                        </tr>
		                        <tr>
		                           <td class="titulotable" width="19%" align="right" style="vertical-align: top !important; background-color: #eee;"> SigningTime </td>
		                            <td class="conteudotable">{{atributos.signingtime}}</td> 
		                        </tr>
		                        <tr>
		                           <td class="titulotable" width="19%" align="right" style="vertical-align: top !important; background-color: #eee;"> MessageDigest </td>
		                            <td class="conteudotable">{{atributos.messagedigest}}</td> 
		                        </tr>
		                        <tr>
		                           <td class="titulotable" width="19%" align="right" style="vertical-align: top !important; background-color: #eee;"> SigPolicyId </td>
		                            <td class="conteudotable">{{atributos.sigpolicyId}}</td> 
		                        </tr>
		                        <tr>
		                           <td class="titulotable" width="19%" align="right" style="vertical-align: top !important; background-color: #eee;"> ContentType </td>
		                            <td class="conteudotable">{{atributos.contenttype}}</td> 
		                        </tr>
		                        <tr>
		                           <td class="titulotable" width="19%" align="right" style="vertical-align: top !important; background-color: #eee;"> SigningCertificateV2 </td>
		                            <td class="conteudotable">{{atributos.signingcertificatev2}}</td> 
		                        </tr>
		                    </tbody>
		                	</table>
		                </div>
	            	</div>
	            </div>
	        </div>

	      </div><!-- FInal do modalbody-->
	      <div class="modal-footer">
	        <button type="button" class="btn btn-default" data-dismiss="modal">Fechar</button>
	      </div>
	    </div><!-- /.modal-content -->
	  </div><!-- /.modal-dialog -->
	</div><!-- /.modal -->
</template>
<script>
	export default{
		data(){
			return{
			}
		},
		ready(){

		},
		props:['line', 'dadosmodal', 'certificado', 'emissorum', 'emissordois', 'emissortreis', 'atributos'],
	}
</script>


// WEBPACK FOOTER //
// infomodal.vue?fe383d2c